<template>
    <div class="base-nav">
        <div class='base-nav-wrap'>
            <el-menu :default-active="activeIndex" mode="horizontal" @select="handlerSelect" active-text-color="rgba(20, 153, 220, 1)">
                <el-menu-item v-if="showHomeNav" index="/">
                    <router-link to="/">{{dict[language].home}}</router-link>
                </el-menu-item>
                <template v-for="(nav, index) in dataList">
                    <el-submenu 
                        :key="index" 
                        :index="nav.id" 
                        v-if="nav.status && nav.type == 0">
                        <template slot="title">{{handlerSwitchLanguage(language, 'name', nav)}}</template>
                        <el-menu-item 
                            v-for="child in filterMenu(nav.children||[])" :key="child.id" 
                            :index="handlePath([nav, child, handlerSwitchLanguage(language, 'name', nav), handlerSwitchLanguage(language, 'name', child)])">
                            {{handlerSwitchLanguage(language, 'name', child)}}
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item 
                        :index="handlePath([nav, nav, handlerSwitchLanguage(language, 'name', nav)])"
                        :key="index" v-else-if="nav.status">
                        {{handlerSwitchLanguage(language, 'name', nav)}}
                    </el-menu-item>
                </template>
            </el-menu>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import dict from '@/assets/json/dictionaries.json'
  import mixs from "@/mixs"

  export default {
    name: "BaseNav",
    mixins: [mixs],
    inject: ['language'],
    data() {
        return {
            showHomeNav: false,
            activeIndex: null,
            dict
        }
    },
    watch: {
        "$route"(_new) {
            this.showHomeNav = _new.path !== "/"
            this.activeIndex = null
        }
    },
    computed: {
        ...mapState({
            dataList: state => state.nav
        }),
        filterMenu () {
            return menu => {
                return menu.filter((item) => {
                    return item.status === 1
                })
            }
            
        } 
    },
    methods: {
        handlerSelect(json) {
            if(json === '/') return;
            const obj = JSON.parse(json);
            if (obj.evtObj.type === 1) { // 外链
                window.open(this.handlerSwitchLanguage(this.language, 'url', obj.evtObj))
            } else if(obj.evtObj.type === 2) { // 导航类
                this.$router.push({
                    path: obj.to,
                    query: {
                        paths: JSON.stringify(obj.path),
                        menu: JSON.stringify(obj.menu)
                    }
                })
            }
        },

        handlePath([menu, evtObj, ...paths]) {
            const obj = {
                to: `/contentList/${evtObj.id}`,
                path: paths,
                evtObj,
                menu
            }
            return JSON.stringify(obj)
        }
    }
  }
</script>

<style lang="less">
    .base-nav {
        width: 100%;
        margin: 0 auto;
        border-bottom: 1px solid #dcdfe6;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 10;
        pointer-events: none;
        & > .base-nav-wrap {
            width: max-content;
            margin: 0 auto;
            pointer-events: initial;
            .base-nav-item {
                height: 40px;
                display: inline-block;
                margin: 0 20px;
                font-size: 16px;
                color: rgba(89, 87, 87, 1);
                cursor: pointer;
                &.active {
                    color: rgba(20, 153, 220, 1);
                    position: relative;
                    &::after {
                        content: '';
                        width: 100%;
                        height: 5px;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        background: rgba(20, 153, 220, 1);
                    }
                }
            }
            .el-menu.el-menu--horizontal {
                border: none;
            }
        }
        .el-menu--horizontal>.el-submenu .el-submenu__title, .el-menu-item {
            font-size: 15px;
            font-weight: 500;
            color: #3F3F3F !important;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: 4px solid #409EFF;
        }
    }

</style>
